<template>
  <div>
    <img
      src="/images/blog_img.png"
      alt="blog image"
      class="image 128x128 min-height-10 object-fit-cover"
    />
    <div
      :class="
        screen === 'mobile' ? 'pa-4' : 'padding-right-70px padding-left-70px'
      "
    >
      <blog-list-page></blog-list-page>
    </div>
  </div>
</template>
<script>
import BlogListPage from '@/components/Blog/BlogListPage'
import { mapGetters } from 'vuex'
export default {
  components: { BlogListPage },
  computed: {
    ...mapGetters({ screen: 'getScreen' })
  },
  head() {
    return {
      title: `Blogs | Rojgari`
    }
  }
}
</script>
